/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Output_StyleInputs */

const en_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output & Style`)
};

const fr_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortie et style`)
};

const de_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabe & Stil`)
};

const it_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output e stile`)
};

const ru_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вывод и стиль`)
};

const es_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida y estilo`)
};

const zh_cn2_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出与风格`)
};

const ja_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力とスタイル`)
};

const hi_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट और शैली`)
};

const pt_pt2_ad_section_output_style = /** @type {(inputs: Ad_Section_Output_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída e estilo`)
};

/**
* | output |
* | --- |
* | "Output & Style" |
*
* @param {Ad_Section_Output_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_output_style = /** @type {((inputs?: Ad_Section_Output_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Output_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_output_style(inputs)
	if (locale === "de") return de_ad_section_output_style(inputs)
	if (locale === "it") return it_ad_section_output_style(inputs)
	if (locale === "ru") return ru_ad_section_output_style(inputs)
	if (locale === "es") return es_ad_section_output_style(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_output_style(inputs)
	if (locale === "ja") return ja_ad_section_output_style(inputs)
	if (locale === "hi") return hi_ad_section_output_style(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_output_style(inputs)
	return en_ad_section_output_style(inputs)
});